import React from 'react';
import { motion } from 'framer-motion';
import { CheckBadgeIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';

const InvSlide09Validation: React.FC = () => {
  const schools = [
    { name: 'Cranbrook', type: 'Private', status: 'Signed off — Year 8 Maths pilot (Term 2)', color: '#10b981' },
    { name: 'Shore', type: 'Private', status: 'Signed off — Year 8 Maths pilot (start TBC)', color: '#10b981' },
    { name: 'PLC Sydney', type: 'Private', status: 'Consulted', color: '#0ea5e9' },
    { name: 'Bronte Public', type: 'Public', status: 'Consulted', color: '#64748b' },
    { name: 'Chatswood Public', type: 'Public', status: 'Consulted', color: '#64748b' },
    { name: 'Fairfield (West)', type: 'Public', status: 'Consulted', color: '#64748b' },
  ];

  const learnings = [
    'Some classes combine multiple year levels',
    'Teachers create multiple cohorts within same class',
    'Some want to block progress beyond modules',
    'Others let students go ahead freely',
    'Need ability to schedule and reorder modules',
    'Baseline testing required upfront',
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-3 text-center"
      >
        School Validation
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-10 text-center"
      >
        We spoke to public and private schools across Sydney to understand real requirements
      </motion.p>

      <div className="flex gap-10 w-full max-w-6xl">
        {/* Left: Schools */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
          className="flex-1"
        >
          <h3 className="text-xl font-semibold text-white mb-5 flex items-center gap-2">
            <ChatBubbleLeftRightIcon className="w-6 h-6 text-[#0ea5e9]" />
            Schools We Consulted
          </h3>

          <div className="grid grid-cols-2 gap-3">
            {schools.map((school) => (
              <div
                key={school.name}
                className="flex items-center gap-3 p-4 rounded-xl"
                style={{
                  background: `${school.color}10`,
                  border: `1px solid ${school.color}30`,
                }}
              >
                {school.status.startsWith('Signed off') ? (
                  <CheckBadgeIcon className="w-6 h-6" style={{ color: school.color }} />
                ) : (
                  <div className="w-6 h-6 rounded-full border-2" style={{ borderColor: school.color }} />
                )}
                <div>
                  <div className="font-semibold text-white">{school.name}</div>
                  <div className="text-xs text-[#94a3b8]">
                    {school.type} • <span style={{ color: school.color }}>{school.status}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            className="mt-5 p-4 rounded-xl"
            style={{
              background: 'rgba(16, 185, 129, 0.15)',
              border: '2px solid rgba(16, 185, 129, 0.4)',
            }}
          >
            <p className="text-white text-center">
              <span className="font-bold text-[#10b981]">Two schools signed off</span> for Year 8 Maths pilots
            </p>
          </div>
        </motion.div>

        {/* Right: Learnings */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4 }}
          className="w-96"
        >
          <h3 className="text-xl font-semibold text-white mb-5">Key Learnings</h3>

          <div
            className="p-5 rounded-xl"
            style={{
              background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
          >
            <div className="space-y-3">
              {learnings.map((learning, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#0ea5e9] mt-2 flex-shrink-0" />
                  <span className="text-[#94a3b8]">{learning}</span>
                </div>
              ))}
            </div>
          </div>

          <div
            className="mt-4 p-4 rounded-xl text-center"
            style={{
              background: 'rgba(245, 158, 11, 0.15)',
              border: '1px solid rgba(245, 158, 11, 0.3)',
            }}
          >
            <p className="text-white text-sm">
              <span className="font-bold text-[#f59e0b]">Result:</span> Comprehensive system that gives teachers freedom on how they work with modules
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default InvSlide09Validation;
